import { AlertCircle, AlertTriangle, CheckCircle2, Info } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '../../lib/cn';

interface AlertProps {
  variant?: 'error' | 'success' | 'info' | 'warning';
  title?: string;
  children: ReactNode;
  className?: string;
}

const VARIANT_CLASSES = {
  error: 'border-danger/40 bg-danger/5 text-danger',
  success: 'border-success/40 bg-success/5 text-success',
  info: 'border-info/40 bg-info/5 text-marca-gris',
  // warning: tono ámbar discreto para avisos no bloqueantes.
  warning: 'border-amber-500/40 bg-amber-50 text-amber-800',
} as const;

const ICONS = {
  error: AlertCircle,
  success: CheckCircle2,
  info: Info,
  warning: AlertTriangle,
} as const;

export function Alert({ variant = 'info', title, children, className }: AlertProps): JSX.Element {
  const Icon = ICONS[variant];
  return (
    <div
      role="alert"
      className={cn('flex gap-3 rounded-md border p-3 text-sm', VARIANT_CLASSES[variant], className)}
    >
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="flex-1">
        {title && <div className="mb-1 font-medium">{title}</div>}
        <div>{children}</div>
      </div>
    </div>
  );
}
